import { supabase } from "@/integrations/supabase/client";

/**
 * Signed-in user from the locally saved session, shaped like auth.getUser().
 * Screen hooks only need the id to scope reads (row-level security still
 * checks the token server-side), so they skip a login-service round trip.
 * The route guard keeps using getUser() for the real check.
 */
export async function sessionUser() {
  const { data, error } = await supabase.auth.getSession();
  return { data: { user: data.session?.user ?? null }, error };
}
